import {getEnumRegattaStatusName} from "@/autogen/bundle";
import {getStrWithLowFirstLetter} from "@/util";

const REGATTA_STATUS_NEW      = 0;
const REGATTA_STATUS_ACTIVE   = 1;
const REGATTA_STATUS_FINISHED = 2;

export class Regatta {
  static #statusesNameMap = {
    [REGATTA_STATUS_NEW]:      'запланирована',
    [REGATTA_STATUS_ACTIVE]:   'активна',
    [REGATTA_STATUS_FINISHED]: 'завершена',
  };

  static isNew(status) {
    return status == REGATTA_STATUS_NEW;
  }

  static isActive(status) {
    return status == REGATTA_STATUS_ACTIVE;
  }

  static isFinished(status) {
    return status == REGATTA_STATUS_FINISHED;
  }

  static getStatusName(status) {
    return Regatta.#statusesNameMap[status];
  }

  static hasABTest(abTestId) {
    return abTestId !== 0;
  }
}

const PARTICIPANT_STATUS_IS_NEW      = 0;
const PARTICIPANT_STATUS_IN_PROGRESS = 1;
const PARTICIPANT_STATUS_FINISHED    = 2;

export class Participant {
  static #statusesNameMap = {
    [PARTICIPANT_STATUS_IS_NEW]:      'is new',
    [PARTICIPANT_STATUS_IN_PROGRESS]: 'not finished',
    [PARTICIPANT_STATUS_FINISHED]:    'finished',
  };

  static isNew(status) {
    return status == PARTICIPANT_STATUS_IS_NEW;
  }

  static inProgress(status) {
    return status == PARTICIPANT_STATUS_IN_PROGRESS;
  }

  static isFinished(status) {
    return status == PARTICIPANT_STATUS_FINISHED;
  }

  static getStatusName(status) {
    return Participant.#statusesNameMap[status];
  }
}

export const DEFAULT_REGATTA_AUDIENCE   = 0;

export const REGATTA_AUDIENCE_ALL       = 0;
export const REGATTA_AUDIENCE_QA        = 1;
export const REGATTA_AUDIENCE_EXCEPT_QA = 2;

/**
 * Options for component b-form-select.
 * @returns {PlayerGroupOption[]}
 */
export function getRegattaAudienceVerbose() {
  const options = [];

  const audiences = [REGATTA_AUDIENCE_ALL, REGATTA_AUDIENCE_QA, REGATTA_AUDIENCE_EXCEPT_QA];
  for(const audience of audiences) {
    const option = {
      value: audience,
      text: getRegattaAudienceNameVerbose(audience),
    };
    options.push(option);
  }

  return options;
}

export function getRegattaAudienceNameVerbose(audience) {
  switch(audience) {
    case REGATTA_AUDIENCE_ALL:       return 'все';
    case REGATTA_AUDIENCE_QA:        return 'тестеры';
    case REGATTA_AUDIENCE_EXCEPT_QA: return 'все кроме тестеров';
  }
  return `Unknown audience ${audience}.`;
}

/**
 * @param {number} status
 * @returns {Object}
 */
export function getRegattaClass(status) {
  return {
    'finished-regatta': Regatta.isFinished(status),
  };
}

/**
 * @param {number} status
 * @returns {Object}
 */
export function getRegattaStatusClass(status) {
  return {
    'active-regatta': Regatta.isActive(status),
  };
}

// options for component b-form-select
export function getRegattaStatusOptionsForFilter() {
  const options = getRegattaStatusOptions();

  const anyOption = {
    value: 3,
    text: 'any',
  };
  options.unshift(anyOption);

  return options;
}

function getRegattaStatusOptions() {
  const options = [];

  const statusList = getRegattaStatuses();
  for(const status of statusList) {
    const option = {
      value: status,
      text: Regatta.getStatusName(status),
      // text: getRegattaStatusName(status),
    };
    options.push(option);
  }

  return options;
}

/**
 * @param {number} status
 * @returns {string}
 */
export function getRegattaStatusName(status) {
  const name = getEnumRegattaStatusName(status);
  return getStrWithLowFirstLetter(name);
}

function getRegattaStatuses() {
  return [
    REGATTA_STATUS_NEW,
    REGATTA_STATUS_ACTIVE,
    REGATTA_STATUS_FINISHED,
  ];
}